// CJS/ESM interop wrapper for react-helmet-async.
// Under SSR (Vite module runner), the package resolves as CommonJS and only
// exposes a default export; in the browser build the named exports exist.
// All app code imports Helmet/HelmetProvider from here.
import * as pkg from "react-helmet-async";

const mod: typeof pkg = ((pkg as unknown as { default?: typeof pkg }).default ?? pkg) as typeof pkg;

export const Helmet = mod.Helmet ?? (pkg as typeof pkg).Helmet;
export const HelmetProvider = mod.HelmetProvider ?? (pkg as typeof pkg).HelmetProvider;
